import { defineStore } from "pinia";
import { ref, computed } from "vue";
import {
  getCurrentZoom,
  isZooming,
  addZoomListener,
  removeZoomListener,
  fixZoomLayout,
} from "@/utils/zoomUtils";

export const useAppStore = defineStore("app", () => {
  // 状态
  const sidebarCollapsed = ref(true); // 默认收缩侧边栏
  const sidebarVisible = ref(false);
  const windowWidth = ref(window.innerWidth);
  const currentZoom = ref(getCurrentZoom());
  const isZoomingState = ref(isZooming());

  // 计算属性
  const isMobile = computed(() => windowWidth.value < 1024);

  // 方法
  const toggleSidebarCollapse = () => {
    sidebarCollapsed.value = !sidebarCollapsed.value;
  };

  const setSidebarCollapsed = (collapsed: boolean) => {
    sidebarCollapsed.value = collapsed;
  };

  const toggleSidebarVisible = () => {
    sidebarVisible.value = !sidebarVisible.value;
  };

  const setSidebarVisible = (visible: boolean) => {
    sidebarVisible.value = visible;
  };

  const updateWindowWidth = (width: number) => {
    windowWidth.value = width;
  };

  const updateZoomState = () => {
    currentZoom.value = getCurrentZoom();
    isZoomingState.value = isZooming();
  };

  const handleZoomChange = () => {
    updateZoomState();
    fixZoomLayout();
  };

  // 初始化窗口大小监听
  const initWindowListener = () => {
    const handleResize = () => {
      updateWindowWidth(window.innerWidth);
      updateZoomState();
      // 移动端时自动收起侧边栏
      if (isMobile.value) {
        setSidebarCollapsed(true);
        setSidebarVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // 添加缩放事件监听
    addZoomListener(handleZoomChange);

    // 返回清理函数
    return () => {
      window.removeEventListener("resize", handleResize);
      removeZoomListener(handleZoomChange);
    };
  };

  return {
    // 状态
    sidebarCollapsed,
    sidebarVisible,
    windowWidth,
    currentZoom,
    isZoomingState,

    // 计算属性
    isMobile,

    // 方法
    toggleSidebarCollapse,
    setSidebarCollapsed,
    toggleSidebarVisible,
    setSidebarVisible,
    updateWindowWidth,
    updateZoomState,
    handleZoomChange,
    initWindowListener,
  };
});
